import { React, useState, useEffect } from "react";
import { Modal } from "@mui/material";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";

const FORM_INICIAL = { categoriaId: "", comentario: "", fechaEstimadaCierre: "" };

// Colores fijos por categoría (verde/azul/ámbar) — se elige por hash del
// nombre para que cada categoría se vea siempre igual sin depender de la BD.
const CATEGORIA_COLORES = ["green"];
const categoriaColor = (nombre) => {
    if (!nombre) return "green";
    let hash = 0;
    for (let i = 0; i < nombre.length; i++) hash = (hash * 31 + nombre.charCodeAt(i)) >>> 0;
    return CATEGORIA_COLORES[hash % CATEGORIA_COLORES.length];
};

export const ComentariosOTModal = ({ open, onClose, ot, row }) => {
    const [loader, setLoader] = useState({
        mostrar: false, alerta: false, error: false, mensaje: "",
    });
    const [categorias, setCategorias] = useState([]);
    const [historial, setHistorial] = useState([]);
    const [form, setForm] = useState(FORM_INICIAL);

    useEffect(() => {
        if (!open || !ot) return;
        setForm(FORM_INICIAL);
        cargarCategorias();
        cargarHistorial();
    }, [open]);

    const cargarCategorias = () => {
        request
            .get("OrdenTrabajoComentario/Categorias")
            .then((result) => setCategorias(Array.isArray(result) ? result : []))
            .catch((error) => {
                Swal.fire("COMENTARIOS OT", JSON.stringify(error), "error");
            });
    };

    const cargarHistorial = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get(`OrdenTrabajoComentario/Listado?OrdenTrabajoId=${ot}`)
            .then((result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setHistorial(Array.isArray(result) ? result : []);
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("COMENTARIOS OT", JSON.stringify(error), "error");
            });
    };

    const validar = () => {
        if (!form.categoriaId) {
            Swal.fire("COMENTARIOS OT", "Selecciona una categoría", "warning");
            return false;
        }
        if (form.comentario.trim().length <= 5) {
            Swal.fire("COMENTARIOS OT", "El comentario debe tener más de 5 letras", "warning");
            return false;
        }
        if (!form.fechaEstimadaCierre) {
            Swal.fire("COMENTARIOS OT", "Selecciona la fecha estimada de cierre", "warning");
            return false;
        }
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        const fechaCierre = new Date(`${form.fechaEstimadaCierre}T00:00:00`);
        if (fechaCierre < hoy) {
            Swal.fire("COMENTARIOS OT", "La fecha estimada de cierre no puede ser una fecha ya pasada", "warning");
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader((prev) => ({ ...prev, mostrar: true }));

        const post = {
            ordenTrabajoId: ot,
            categoriaId: Number(form.categoriaId),
            comentario: form.comentario.trim(),
            fechaEstimadaCierre: form.fechaEstimadaCierre,
        };
        request
            .post("OrdenTrabajoComentario/Guardar", post)
            .then(async (result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setHistorial(Array.isArray(result) ? result : []);
                await Swal.fire("COMENTARIOS OT", "Comentario registrado con éxito", "success");
                setForm(FORM_INICIAL);
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("COMENTARIOS OT", JSON.stringify(error), "error");
            });
    };

    const handleCancelar = () => {
        setForm(FORM_INICIAL);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="comentarios-ot-modal-formulario">
                <div className="comentarios-ot-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="comentarios-ot-modal">
                        <PlantillaScreen
                            titulo={
                                <span className="comentarios-ot-modal-titulo-wrap">
                                    Comentarios
                                    
                                </span>
                            }
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>

                            <LoaderScreen loader={loader} />

                            <div className="comentarios-ot-modal-content">
                                <div className="comentarios-ot-modal-columns">

                                    {/* ── Columna izquierda: info de la OT + formulario ── */}
                                    <div className="comentarios-ot-modal-col-izq">
                                        <div className="comentarios-ot-modal-col-scroll scroll-4">

                                            {row && (
                                                <div className="comentarios-ot-modal-info">
                                                    <div className="comentarios-ot-modal-info-fila">
                                                        <div className="comentarios-ot-modal-info-campo">
                                                            <span>OT</span>
                                                            <strong>{row.v_ot ?? "—"}</strong>
                                                        </div>
                                                        <div className="comentarios-ot-modal-info-campo">
                                                            <span>Tipo</span>
                                                            <strong>{row.v_tipo || "—"}</strong>
                                                        </div>
                                                        <div className="comentarios-ot-modal-info-campo">
                                                            <span>Antigüedad</span>
                                                            <strong>{row.v_antiguedad ?? "—"} días</strong>
                                                        </div>
                                                    </div>

                                                    <div className="comentarios-ot-modal-info-fila">
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-full">
                                                            <span>Cliente</span>
                                                            <strong>{row.cliente || "—"}</strong>
                                                        </div>
                                                    </div>

                                                    <div className="comentarios-ot-modal-info-fila">
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-full">
                                                            <span>NIP</span>
                                                            <strong>{row.v_nip || "—"}</strong>
                                                        </div>
                                                    </div>

                                                    <div className="comentarios-ot-modal-info-fila">
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-money">
                                                            <span>Mano de obra</span>
                                                            <strong>${FormatMoney(row.v_manobra, 0)}</strong>
                                                        </div>
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-money">
                                                            <span>Refacciones</span>
                                                            <strong>${FormatMoney(row.v_refacciones, 0)}</strong>
                                                        </div>
                                                    </div>

                                                    <div className="comentarios-ot-modal-info-fila">
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-money">
                                                            <span>Trabajo foráneo</span>
                                                            <strong>${FormatMoney(row.v_trabajoforaneo, 0)}</strong>
                                                        </div>
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-money">
                                                            <span>Kilometraje</span>
                                                            <strong>
                                                                ${Number(row.v_Kilometraje || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 })}
                                                            </strong>
                                                        </div>
                                                    </div>

                                                    <div className="comentarios-ot-modal-info-fila">
                                                        <div className="comentarios-ot-modal-info-campo comentarios-ot-modal-info-campo-full">
                                                            <span>Descripción de falla</span>
                                                            <p>{row.v_descfalla || "—"}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <label className="comentarios-ot-modal-label">Categoría</label>
                                            <select
                                                className="comentarios-ot-modal-select"
                                                value={form.categoriaId}
                                                onChange={(e) => setForm((prev) => ({ ...prev, categoriaId: e.target.value }))}
                                            >
                                                <option value="">Selecciona una categoría</option>
                                                {categorias.map((cat) => (
                                                    <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                                                ))}
                                            </select>

                                            <label className="comentarios-ot-modal-label">Comentario</label>
                                            <textarea
                                                className="comentarios-ot-modal-textarea"
                                                rows={4}
                                                placeholder="Motivo por el que no se ha terminado el trabajo"
                                                value={form.comentario}
                                                onChange={(e) => setForm((prev) => ({ ...prev, comentario: e.target.value }))}
                                            />
                                            

                                            <label className="comentarios-ot-modal-label">Fecha estimada de cierre</label>
                                            <input
                                                className="comentarios-ot-modal-fecha"
                                                type="date"
                                                min={new Date().toISOString().slice(0, 10)}
                                                value={form.fechaEstimadaCierre}
                                                onChange={(e) => setForm((prev) => ({ ...prev, fechaEstimadaCierre: e.target.value }))}
                                            />
                                        </div>

                                        <div className="comentarios-ot-modal-buttons">
                                            <button
                                                className="comentarios-ot-modal-button-cancelar"
                                                onClick={handleCancelar}
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                className="comentarios-ot-modal-button-guardar"
                                                onClick={handleGuardar}
                                                disabled={loader.mostrar}
                                            >
                                                Guardar
                                            </button>
                                        </div>
                                    </div>

                                    {/* ── Columna derecha: historial tipo timeline ── */}
                                    <div className="comentarios-ot-modal-col-der">
                                        <div className="comentarios-ot-modal-historial-titulo-row">
                                            <div className="comentarios-ot-modal-historial-titulo">Historial de comentarios</div>
                                            {historial.length > 0 && (
                                                <span className="comentarios-ot-modal-historial-badge">{historial.length}</span>
                                            )}
                                        </div>

                                        <div className="comentarios-ot-modal-timeline-wrap scroll-4">
                                            {historial.length > 0 ? (
                                                <ul className="comentarios-ot-modal-timeline">
                                                    {historial.map((item) => {
                                                        const color = categoriaColor(item.categoriaNombre);
                                                        return (
                                                            <li key={item.id} className="comentarios-ot-modal-timeline-item">
                                                                <span className={`comentarios-ot-modal-timeline-marker comentarios-ot-modal-color-${color}`} />
                                                                <div className="comentarios-ot-modal-timeline-card">
                                                                    <div className="comentarios-ot-modal-item-cabecera">
                                                                        <span className={`comentarios-ot-modal-item-categoria comentarios-ot-modal-color-${color}`}>
                                                                            {item.categoriaNombre}
                                                                        </span>
                                                                        <span className="comentarios-ot-modal-item-fecha">
                                                                            {new Date(item.fechaRegistro).toLocaleString("es-MX")}
                                                                            {item.usuarioRegistro ? ` · Usuario ${item.usuarioRegistro}` : ""}
                                                                        </span>
                                                                    </div>
                                                                    <div className="comentarios-ot-modal-item-texto">{item.comentario}</div>
                                                                    {item.fechaEstimadaCierre && (
                                                                        <div className="comentarios-ot-modal-item-cierre">
                                                                            Cierre estimado: {new Date(item.fechaEstimadaCierre).toLocaleDateString("es-MX")}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            ) : (
                                                !loader.mostrar && (
                                                    <p className="comentarios-ot-modal-vacio">
                                                        Sin comentarios registrados todavía.
                                                    </p>
                                                )
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ComentariosOTModal;
